import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// After the library's own stylesheet on purpose: our dropdown styling has to
// win over vue-select's defaults, and load order is what decides that between
// two rules of equal weight. Loaded first, everything we set here for the
// lists was silently overridden.
import "./styles/app.scss";
import { installProblemLog } from "./modules/problem-log";

const app = createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .component("v-select", vSelect);

// Before mount: an error thrown during the first render is exactly the kind
// nobody can report afterwards.
installProblemLog(app);

app.mount("#app");
